<template lang="pug">
  div(:class="`container-${this._uid}`")
    h2.section-title {{this.title}}
    vue-markdown.desc(:source="this.description")

    ul.collection.grid(:class="this.classes")
      li.item(v-for="(d, i) in this.items")
        a.directLink(v-if="d.url" :href="d.url")
          div.itemImage(v-if="d.image")
            image-block(:payload="d.image")
          div.itemContent
            h3.title {{ d.title }}
            vue-markdown(:source='d.desc' class="desc")
        router-link(v-if="!d.url" :to="{ path: d.slug ? '/' + d.slug : '/' + d.type + '/' + d.id}" :key="'collection-item-' + i")
          div.itemImage(v-if="d.image")
            image-block(:payload="d.image")
          div.itemContent
            h3.title {{ d.title }}
            vue-markdown(:source='d.desc' class="desc")
    //- router-link.section-link.button.minimal(v-show="this.link" :to="{ path: this.link }") {{ 'view all ' + this.payload.fields.name && this.payload.fields.name.toLowerCase() }}
</template>

<script>
import Vue from 'vue'
import imageBlock from '@/components/imageBlock'

// component instance
var List = Vue.component('list', {
  name: 'List',
  mixins: [],
  components: { imageBlock },
  props: {
    title: {
      default: '',
      type: String
    },
    description: {
      default: '',
      type: String
    },
    items: {
      default: () => {
        return {
          title: '',
          desc: '',
          image: {
            file: {
              name: '',
              width: 0,
              height: 0
            },
            url: '',
            title: ''
          }
        }
      },
      type: Array
    },
    classes: {
      default: '',
      type: String
    },
    layout: {
      default: '',
      type: String
    }
  },
  data: function () {
    return {
    }
  },
  watch: {
  },
  methods: {
  },
  computed: {
  },
  created () {
  },
  mounted () {
  },
  beforeCreate () {
  },
  beforeUpdate () {
  },
  beforeDestroy () {
  }
})

// export component
export default List
</script>

<style scoped lang="scss">
.section-container{
  margin-top: 3rem;
}

.section-title{
  text-align: center;
  margin: measure(sm) 0;
}

.col-2 .collection.grid, .two-up .collection.grid {
  grid: auto-flow auto / repeat(2, [line1 line2] minmax(auto, 50%));
  @include breakpoint(small only) {
    grid: none;
  }
}

.col-3 .collection.grid, .three-up .collection.grid {
  grid: auto-flow auto / repeat(3, [line1 line2 line3] minmax(auto, 33.33%));
  @include breakpoint(small only) {
    grid: none;
  }
}
.col-4 .collection.grid, .four-up .collection.grid {
  grid: auto-flow auto / repeat(4, [line1 line2 line3 line4] minmax(auto, 25%));
  font-size: 80%;
  @include breakpoint(medium only) {
    grid: auto-flow auto / repeat(2, [line1 line2] minmax(auto, 50%));
  }
  @include breakpoint(small only) {
    grid: none;
  }
}
.collection .grid.col-6 {
  grid: auto-flow auto / repeat(6, [line1 line2 line3 line4 line5 line6] minmax(auto, 16.66%));
  font-size: 80%;
  @include breakpoint(medium only) {
    grid: auto-flow auto / repeat(4, [line1 line2 line3 line4] minmax(auto, 25%));
  }
  @include breakpoint(small only) {
    grid: none;
  }
}
.collection .grid.col-8 {
  grid: auto-flow auto / repeat(8, [line1 line2 line3 line4 line5 line6 line7 line8] minmax(auto, 12.5%));
  font-size: 80%;
  @include breakpoint(medium only) {
    grid: auto-flow auto / repeat(4, [line1 line2 line3 line4] minmax(auto, 25%));
  }
  @include breakpoint(small only) {
    grid: none;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/List.vue